module.exports = __webpack_public_path__ + "img/img45.c73e6bdf.png";